import { render, staticRenderFns } from "./medal-star.vue?vue&type=template&id=67176d26&"
import script from "./medal-star.vue?vue&type=script&lang=js&"
export * from "./medal-star.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports